import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { AdminLoginInfo } from '../../../models/login/admin-login-info.model';
import { LoginVerification } from '../../../models/login/login-verification.model';
import { TokenInfo } from '../../../models/login/token-info.model';

@Injectable({
	providedIn: 'root'
})
export class LocalStoreService {
	data: LoginVerification = new LoginVerification();

	constructor(
		private router: Router
	) { }

	saveUtmParams(params: Params) {
		debugger;
		//source=affiliate&medium=Cappsinfo&campaign=tc&utmTerm=myTermDao2&utmContent=blog

		params = this.toLowerParams(params);

		if (params["utm_source"])
			this.data.UtmSource = params["utm_source"];
		else
			this.data.UtmSource = params["utmsource"];

		if (params["utm_medium"])
			this.data.UtmMedium = params["utm_medium"];
		else
			this.data.UtmMedium = params["utmmedium"];

		if (params["utm_campaign"])
			this.data.UtmCampaign = params["utm_campaign"];
		else
			this.data.UtmCampaign = params["utmcampaign"];

		if (params["utm_term"])
			this.data.UtmTerm = params["utm_term"];
		else
			this.data.UtmTerm = params["utmterm"];

		if (params["utm_content"])
			this.data.UtmContent = params["utm_content"];
		else
			this.data.UtmContent = params["utmcontent"];

		if (params["utm_promo"])
			this.data.UtmPromo = params["utm_promo"];
		else
			this.data.UtmPromo = params["utmpromo"];

		if (params["utm_deviceid"])
			this.data.UtmDeviceId = params["utm_deviceid"];
		else
			this.data.UtmDeviceId = params["utmdeviceid"];
			
		if (params["utm_appname"])
			this.data.UtmAppid = params["utm_appname"];
		else
			this.data.UtmAppid = params["utmappname"];

		if (params["utm_appsflyersid"])
			this.data.UtmAppsflyerid = params["utm_appsflyersid"];
		else
			this.data.UtmAppsflyerid = params["utmappsflyersid"];

		if (params["utm_advertisingid"])
			this.data.UtmAdvertisementId = params["utm_advertisingid"];
		else
			this.data.UtmAdvertisementId = params["utmadvertisingid"];

		if (params["utm_osversion"])
			this.data.UtmOSversion = params["utm_osversion"];
		else
			this.data.UtmOSversion = params["utmosversion"];

		if (params["utm_attconsent"])
			this.data.UtmATTConsent = params["utm_attconsent"];
		else
			this.data.UtmATTConsent = params["utmattconsent"];

		if (params["lg-code"])
			this.data.LgCode = params["lg-code"];

		if (params["lc-code"])
			this.data.LcCode = params["lc-code"];

		if (params["source-code"]) 
			this.data.SourceCode = params["source-code"];
	}

	toLowerParams(params: Params): Params {
		const lowerParams: Params = {};
		for (const key in params) {
			lowerParams[key.toLowerCase()] = params[key];
		}

		return lowerParams;
	}

	saveData() {
		localStorage.setItem("hdfc_lp_data", JSON.stringify(this.data));
	}

	getUserId(): number {
		return +localStorage.getItem('hdfc_lpadmin_userId');
	}

	getLastLogin(): string {
		return localStorage.getItem('hdfc_lpadmin_user_last_login');
	}

	getUserName(): string {
		return localStorage.getItem('hdfc_lpadmin_userName');
	}

	getToken(): string {
		return localStorage.getItem('hdfc_lpadmin_token');
	}

	getRefreshToken(): string {
		return localStorage.getItem('hdfc_lpadmin_refreshToken');
	}

	updateToken(data: TokenInfo) {
		localStorage.setItem('hdfc_lpadmin_token', data.Token);
		localStorage.setItem('hdfc_lpadmin_refreshToken', data.RefreshToken);
	}

	setDataOnLogin(data: AdminLoginInfo) {
		localStorage.setItem('hdfc_lpadmin_token', data.Auth.Token);
		localStorage.setItem('hdfc_lpadmin_refreshToken', data.Auth.RefreshToken);

		localStorage.setItem('hdfc_lpadmin_userId', data.UserId.toString());
		localStorage.setItem('hdfc_lpadmin_userName', data.UserName);
		localStorage.setItem('hdfc_lpadmin_user_last_login', data.LastLogin ? formatDate(new Date(data.LastLogin), 'dd/MM/yyyy hh:mm a', 'en-US') : 'Never');
	}

	reset() {
		this.data = new LoginVerification();
		localStorage.setItem('hdfc_lpadmin_token', '');
		localStorage.setItem('hdfc_lpadmin_refreshToken', '');
		localStorage.setItem('hdfc_lpadmin_userId', '');
		localStorage.setItem('hdfc_lpadmin_userName', '');
		localStorage.setItem('hdfc_lpadmin_user_last_login', '');
	}

	forceLogout() {
		this.reset();
		localStorage.setItem("forceLogout", "true");
		this.router.navigate(['/login'], { replaceUrl: true });
	}
}
